module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/air-conditioning-icon-342229d87eb683f5de5a94ee220e343e.png";